import firedux from '../firedux'
import {dispatch} from '../store'

import {
  STRIPE_PAYOUT_REQUESTS_ENDPOINT,
  PAYOUT_REQUEST_STATUSES
} from '../../config/constants'

import setCurrentPayoutRequest from '../actions/set_current_payout_request'

const onPayoutRequest = (snapshot) => {
  if (snapshot.exists()) dispatch(setCurrentPayoutRequest(snapshot.val(), snapshot.key()))
}

export const watchCurrentPayoutRequest = (payoutRequestId) => {
  if (!payoutRequestId) return

  const ENDPOINT = `${STRIPE_PAYOUT_REQUESTS_ENDPOINT}/${payoutRequestId}`

  firedux.ref.child(ENDPOINT).on('value', onPayoutRequest)
}

export const unwatchCurrentPayoutRequest = (payoutRequestId) => {
  if (!payoutRequestId) return

  const ENDPOINT = `${STRIPE_PAYOUT_REQUESTS_ENDPOINT}/${payoutRequestId}`

  firedux.ref.child(ENDPOINT).off('value', onPayoutRequest)

  dispatch(setCurrentPayoutRequest(null))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_payout_request.js
 **/